import { render, staticRenderFns } from "./EEscolhaDeTurma.vue?vue&type=template&id=12db2223"
import script from "./EEscolhaDeTurma.vue?vue&type=script&lang=js"
export * from "./EEscolhaDeTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports